import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";
import NexusService from "./NexusService";
import FeatureFlagService from "./FeatureFlagService";

export default class LocationGroupsService extends AbstractService {
	static endpoint = ENDPOINTS.locationGroups;

	static locationGroupsApi = NexusService.locationGroupsApi;

	static apiCoreEndpointsFeature = "use_api_core_endpoints_location_groups";

	static getLocationGroupById(id, queryParams) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			const request = {
				id,
			};
			return this.locationGroupsApi.getLocationGroup(request).then(response => {
				const apiResponse = {
					data: response,
				};
				return apiResponse;
			});
		}
		return this.get({
			endpoint: `${this.endpoint}/${id}`,
			queryParams,
		});
	}

	static getOfficersByLocationGroup(id, queryParams) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			const request = {
				locationGroupId: id,
			};
			if (Object.hasOwn(queryParams, "pageNumber")) {
				request.pageNumber = queryParams.pageNumber;
			}
			if (Object.hasOwn(queryParams, "displayCount")) {
				request.displayCount = queryParams.displayCount;
			}
			return this.locationGroupsApi
				.getPaginatedLocationGroupOfficers(request)
				.then(response => {
					const apiResponse = {
						data: response,
					};
					return apiResponse;
				});
		}
		return this.get({
			endpoint: `${this.endpoint}/${id}/officers`,
			queryParams,
		});
	}

	static getJobsByLocationGroup(id, queryParams) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			const request = {
				locationGroupId: id,
			};
			if (Object.hasOwn(queryParams, "status")) {
				request.status = queryParams.status;
			}
			if (Object.hasOwn(queryParams, "pageNumber")) {
				request.pageNumber = queryParams.pageNumber;
			}
			if (Object.hasOwn(queryParams, "displayCount")) {
				request.displayCount = queryParams.displayCount;
			}
			return this.locationGroupsApi
				.getPaginatedLocationGroupJobEvents(request)
				.then(response => {
					const apiResponse = {
						data: response,
					};
					return apiResponse;
				});
		}
		return this.get({
			endpoint: `${this.endpoint}/${id}/jobevents`,
			queryParams,
		});
	}
}
